import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import downloadLink from "../../../../cores/downloadLink";
import { requestDownload } from "../../../../modules/apis/download";
import compareVersions, { VERSION_CM_7307_DOWNLOAD } from "@cores/version";

const ElementActionItemDownloadV2 = (props) => {
    const {
        resourceType,
        resources,
        expires,
        projectId,
        disabled,
        onClick,
        onClickDownload,
        shouldZip = false,
    } = props;
    const { t } = useTranslation();
    const stageId = useSelector((state) => state.stage.id);
    const stageVersion = useSelector((state) => state.stage.version);
    const stageEndpoint = useSelector((state) => state.stage.endpoint);

    return (
        <li className={"separate"}>
            <button
                type={"button"}
                disabled={disabled}
                onClick={(e) => {
                    if (onClickDownload && compareVersions(VERSION_CM_7307_DOWNLOAD, stageVersion) <= 0) {
                        const resource = resources[0];
                        const keys = [`${resource.prefix ? `/${resource.prefix}` : ""}/${resource.fileName}`];
                        onClickDownload(resource.bucket, keys, "S3", { shouldZip });
                    } else {
                        requestDownload(stageId, stageEndpoint, projectId, {
                            resourceType,
                            resources,
                            expires,
                        })
                            .then((response) => {
                                console.log("download response", response.data);
                                downloadLink(response.data.url);
                                if (onClick) onClick(e);
                            })
                            .catch((error) => {
                                console.error(error);
                                if (onClick) onClick(e);
                            });
                    }
                }}
            >
                {t(`common::label::${"Download"}`)}
            </button>
        </li>
    );
};
ElementActionItemDownloadV2.propTypes = {
    disabled: PropTypes.bool,
    resourceType: PropTypes.string,
    resources: PropTypes.array,
    expires: PropTypes.number,
    projectId: PropTypes.string,
};
ElementActionItemDownloadV2.defaultProps = {
    disabled: false,
};

export default ElementActionItemDownloadV2;
